export default __webpack_public_path__ + "static/media/vincennes3.68aae7f2.jpg";